import mutations from "./mutations";
import actions from "./actions";

export default {
    state: {
        showInterview: false
    },
    mutations,
    actions
}